const updateFile = async ({
  content,
  getBase64,
  allowImg,
  ext,
  reduceImageResolution,
  formFile,
  target,
}) => {
  let image
  let fileSize = content.size
  const files = { ...formFile }
  const idealImageSize = 2000000 // 2MB
  image = await getBase64(content)

  if (allowImg.includes(ext)) {
    // Reduce image if more than the ideal image size
    if (content.size > idealImageSize) {
      image = await reduceImageResolution(content)
      const decoded = atob(image)
      fileSize = decoded.length
    }

    Object.assign(files, {
      [target.id]: {
        id: target.id,
        encoding: 'base64',
        file: `data:${content.type};base64,${image}`,
        decodedFile: atob(image),
        type: content.type,
        size: fileSize,
        content,
      },
    })
  } else {
    Object.assign(files, {
      [target.id]: {
        id: target.id,
        encoding: 'base64',
        file: `data:${content.type};base64,${image}`,
        type: content.type,
        size: fileSize,
        content,
      },
    })
  }

  const sku = target.name
  const required = target.attributes.getNamedItem('widgetreq').value || false

  return {
    sku,
    required,
    files,
  }
}

export default updateFile
